import type { BuildingDetailSections } from "../../../types/buildings-sections/details";

export const buildingDetails: BuildingDetailSections = {
  additionalDetails: {
    title: "Additional Details",
    floors: "Floors",
    parkingSpaces: "Parking Spaces",
    energyRating: "Energy Rating",
    lastRenovationDate: "Last Renovation",
    lastRenovationDates: "Renovation Dates",
    electricityUse: "Electricity Use (kWh/year)",
    heatingUse: "Heating Energy (kWh/year)",
    heatingSource: "Heating Source",
    selectHeatingSource: "Select heating source",
    heatingSources: {
      gas: "Gas",
      electricity: "Electricity",
      district: "District Heating",
      oil: "Oil Heating",
      geothermal: "Geothermal",
      solar: "Solar Energy",
      biomass: "Biomass",
      other: "Other",
    },
  },
  form: {
    name: "Building Name",
    address: "Address",
    registryCode: "Registry Code",
    yearBuilt: "Year Built",
    netArea: "Net Area",
    create: "Create Building",
    success: "Building Created",
    successDescription: "Building has been successfully created.",
    error: "Building creation failed. Please try again.",
    redirecting: "Building created, redirecting…",
  },
  buildingSections: {
    technicalData: "Technical Data",
    rooms: "Rooms",
    technicalSystems: "Technical Systems",
    fireSafety: "Fire Safety",
    structuralMaterials: "Structural Materials",
    finishes: "Finishes",
  },
};
